export default {
  'components.empty.desc.default': 'No data',
  'components.empty.desc.error': 'Error',
  'components.empty.desc.search': 'No data',
  'components.empty.desc.car': 'No data',
  'components.empty.desc.order': 'No data',
  'components.empty.desc.coupon': 'No data',
  'components.empty.desc.collect': 'No data',
  'components.empty.desc.address': 'No data',
  'components.empty.desc.notification': 'No data',
  'components.empty.desc.nodata': 'No data',
};
